export default __webpack_public_path__ + "static/media/tweeter.7409a1c2.png";